export default __webpack_public_path__ + "static/media/menu_my_profile.a25512c8.svg";